//import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const BotaoFlutuante = ({icon, to, onClick, text, posicao}) => {
  const navigate = useNavigate();
  
  const handleClick = (event) => {
    event.preventDefault();
    if (onClick) onClick();
    if (to) navigate(to);
  };
  return (
    <>
      <Link to={handleClick} onClick={handleClick} class={`btn btn-secondary border btn-lg btn-floating-${posicao||'1'}`} role="button">
        <i class={`bi ${icon}`}></i>{text}
      </Link>
    </>
  );
}

export default BotaoFlutuante;